



































































































































import { Component, Vue } from "vue-property-decorator";
import uploadNew from "@/components/uploadNew.vue";
import api from "@/api";
import { Message } from "element-ui";
import {imageUrl} from '@/utils/common'

@Component({
  components: {
    uploadNew: uploadNew
  }
})
export default class AUser extends Vue {
  order = {}
  id: any = ''
  tableData = []
  total = 0
  loading = false
  addDialog = false
  status = {
    0: '未发放',
    1: '已发放',
  }

  search = {
    id: '',
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  }
  shopInfo: any = {}

  add() {
    this.shopInfo = {}
    this.addDialog = true
  }

  handleCancle() {
    this.shopInfo = {}
    this.addDialog = false
  }

      //上传
  fileList: any = [];
  formData = "";
  delFile() {
    this.fileList = [];
  }

  getBase64(file: any) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      let imgResult: any = "";
      reader.readAsDataURL(file);
      reader.onload = function() {
        imgResult = reader.result;
      };
      reader.onerror = function(error) {
        reject(error);
      };
      reader.onloadend = function() {
        resolve(imgResult);
      };
    });
  }

  protected handleExceed(res: any) {
    Message.error({
      message: res,
      duration: 5 * 1000,
    });
  }
  baseInfo = ''
  handleChange(file: any, fileList: any) {
    var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
    const extension = testmsg === 'xlsx'
    if(!extension) {
      this.$message({
        message: '上传文件只能是xlsx格式!',
        type: 'warning'
      });
      this.fileList = [];
      return
    }
    this.getBase64(file.raw).then((res: any) => {
      this.baseInfo = res.split(',')[1]
    })
  }
  handleRemove(file: any, fileList: any) {
    this.fileList = []
    this.baseInfo = ''
    this.shopInfo.excelFile = ''
  }
  handlePreview(file: any) {

  }
  uploadFile(file: any) {
    (this.formData as any).append("file", file.file);
    this.submitUpload()
  }
  submitUpload() {
    let formData = new FormData();
    formData.append("file", (this.fileList[0] as any).raw);
  }

  sureAdd() {
    
    this.shopInfo.excelFile = this.baseInfo
    this.shopInfo.id = this.id
    this.loading = true
    api
      .post('J27758', this.shopInfo)
      .then(res => {
        this.$message.success('操作成功')
        this.addDialog = false
        this.getDetail()
        this.searchTable()
      }).finally(() => {
        this.loading = false
      })
  }


  getDetail() {
    api.post('J27761', {id: this.id}).then(res => {
      this.order = res
    })
  }
 
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 10,
        page: 0,
      };
    }
    this.search.id = this.id
    api.post('J27762', this.search).then(res => {
      this.tableData = res.list
      this.total = res.total
    }).finally(() => {
      this.loading = false;
    })
  }

  activated() {
    let { id } = this.$route.query
    if(id) {
      this.id = id
    }
    this.getDetail()
    this.searchTable()
    
  }
}
